import { Mixin } from 'ts-mixer';
import { always } from 'ramda';
import LinkDescriptionElement from "../../../../elements/LinkDescription.mjs";
import FixedFieldsVisitor from "../../generics/FixedFieldsVisitor.mjs";
import FallbackVisitor from "../../FallbackVisitor.mjs";
class LinkDescriptionVisitor extends Mixin(FixedFieldsVisitor, FallbackVisitor) {
  constructor(options) {
    super(options);
    this.element = new LinkDescriptionElement();
    this.specPath = always(['document', 'objects', 'LinkDescription']);
  }
}
export default LinkDescriptionVisitor;